import { Component, NgZone, OnInit, Injector, ChangeDetectorRef, runInInjectionContext } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Meta } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Subscription, firstValueFrom } from 'rxjs';
import { AuthService } from 'src/app/shared/auth.service';
import { ErrorMatcher } from 'src/app/shared/error.matcher';
import { Md5 } from 'ts-md5/dist/md5';
import { ActivityService } from '../../shared/activity.service';
import { AssignmentService } from '../../shared/assignment.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss'],
	standalone: false
})
export class LoginComponent implements OnInit {
	loginFaild: boolean = false;
	loginBlocked: boolean = false;
	verify: boolean = false;

	emailFormControl = new UntypedFormControl('', [
		Validators.required
	]);
	passwordFormControl = new UntypedFormControl('', [
		Validators.required
	]);

	matcher = new ErrorMatcher();
	protected subscription: Subscription = new Subscription;

	userCred: any;

	loaderStatus: boolean = false;
	disableDisplay: boolean = false;

	signed: boolean = false;
	user: any;

	hide = true;

	quizzes = {
		"1-1": "zone1",
		"1-2": "zone2",
		"1-3": "zone3",
		"1-4": "zone4",
		"2-1": "zone5",
		"2-2": "zone6",
		"2-3": "zone7",
		"3-1": "africa-1",
		"3-2": "africa-2",
		"3-3": "africa-3",
		"4-1": "south-america-1",
		"4-2": "south-america-2",
		"4-3": "south-america-3",
		"5-1": "north-america-1",
		"5-2": "north-america-2",
		"5-3": "north-america-3",
	}

	private channel: BroadcastChannel;

	constructor(
		private auth: AuthService,
		private afs: AngularFirestore,
		private activityService: ActivityService,
		private router: Router,
		private assignmentService: AssignmentService,
		private meta: Meta,
		private ngZone: NgZone,
		private injector: Injector,
		private cdr: ChangeDetectorRef
	) {
		if (localStorage.getItem('cfalHIDE')) {
			localStorage.removeItem('cfalHIDE')
			this.disableDisplay = true;
			this.loaderStatus = true;
		}

		this.meta.updateTag({ name: 'viewport', content: 'width=device-width, initial-scale=1.0' });

		this.channel = new BroadcastChannel('SESSION_ACTIONS');

		this.channel.onmessage = (event) => {
			if (event.data.action == "LOGIN") {
				setTimeout(() => {
					this.ngZone.run(() => this.router.navigate(['/game']));
				}, 1000)
			}
		};
	}

	ngOnInit() {
		this.signed = false;
		var userCredentional = localStorage.getItem("cfal");

		this.auth.logout();
		let today = new Date();
		today.setMonth(today.getMonth() + 12);

		if (userCredentional) {
			this.userCred = JSON.parse(userCredentional);

			if (!this.userCred.email) {
				this.login(true);
			}
		}

		const urlParams = new URLSearchParams(window.location.search);
		const qrCodeID = 'qrmode';

		const qrSignInMode = urlParams.get(qrCodeID);

		if (qrSignInMode) {
			this.loaderStatus = true;
			this.loginFaild = false;
			this.verify = false;

			this.loginViaQRCode(qrSignInMode);
		}
	}

	appendScriptToBody(email: any) {
		if (email) {
			const s = document.createElement("script");
			s.setAttribute('id', 'profitwell-js');
			s.setAttribute('data-pw-auth', 'ddef438d0364d959a508bc1cc2c4d5c1');
			s.setAttribute('type', 'text/javascript');
			s.innerHTML = "(function(i,s,o,g,r,a,m){i[o]=i[o]||function(){(i[o].q=i[o].q||[]).push(arguments)}; a=s.createElement(g);m=s.getElementsByTagName(g)[0];a.async=1;a.src=r+'?auth='+s.getElementById(o+'-js').getAttribute('data-pw-auth');m.parentNode.insertBefore(a,m);})(window,document,'profitwell','script','https://public.profitwell.com/js/profitwell.js');profitwell('start', { 'user_email': '" + email + "' });";
			document.body.appendChild(s);
		}
	}

	async generateAffiliateId(data: any): Promise<any> {
		var result = await firstValueFrom(this.activityService.generateAID(data));
		return result.ID;
	}

	async loginViaGoogle() {
		this.loaderStatus = true;
		this.loginFaild = false;
		this.verify = false;
		var googleRes = await this.auth.googleSignin();

		if (googleRes.user) {
			let userStr = JSON.stringify(googleRes.user);
			let userObj = JSON.parse(userStr);
			localStorage.setItem('currentUser', userStr);

			var parentData = await firstValueFrom(this.activityService.getSelfData({ token: userObj.stsTokenManager.accessToken }));
			var adminData = await firstValueFrom(this.activityService.getSelfData({ collectionID: "adminUserData", token: userObj.stsTokenManager.accessToken }));

			if (!parentData.result && !adminData.result) {
				var displayName = googleRes.user.displayName || 'Era User';
				var parts = displayName.split(" ");
				var affiliateId = await this.generateAffiliateId({ token: userObj.stsTokenManager.accessToken });

				let value = {
					firstName: parts[0],
					lastName: displayName.replace(parts[0], "").trim(),
					email: googleRes.user.email,
					country: "Undefined",
					childs: [],
					regDate: new Date().getTime(),
					affiliateInfo: { affiliateId: affiliateId ? affiliateId : 0, clicks: 0, registrations: 0, freeMonthsEarned: 0 }
				}

				await firstValueFrom(this.activityService.createSelfData({ token: userObj.stsTokenManager.accessToken, parent: value }));

				await this.sleep(3000);

				this.loaderStatus = false;
				this.router.navigate(['/cabinet']);
			} else if (adminData.result) {
				adminData = adminData.result;

				adminData.id = googleRes.user.uid;

				if (adminData['role'] == "super_administrator") {
					localStorage.setItem('superAdmin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('superAdmin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('superAdmin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));

					await firstValueFrom(this.activityService.setSuperAdminAT({ token: userObj.stsTokenManager.accessToken }));

					this.router.navigate(['/admin/super/dashboard']);
				} else {
					localStorage.setItem('quranera_admin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('quranera_admin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('quranera_admin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));
					this.router.navigate(['/admin']);
				}
			} else {
				this.loaderStatus = false;
				this.router.navigate(['/admin/cabinet']);
			}
		} else {
			localStorage.removeItem('currentUser');
			this.loaderStatus = false;
		}
	}

	async loginViaApple() {
		this.loaderStatus = true;
		this.loginFaild = false;
		this.verify = false;
		var googleRes = await this.auth.appleSignin();

		if (googleRes.user) {
			let userStr = JSON.stringify(googleRes.user);
			let userObj = JSON.parse(userStr);
			localStorage.setItem('currentUser', userStr);

			var parentData = await firstValueFrom(this.activityService.getSelfData({ token: userObj.stsTokenManager.accessToken }));
			var adminData = await firstValueFrom(this.activityService.getSelfData({ collectionID: "adminUserData", token: userObj.stsTokenManager.accessToken }));

			if (!parentData.result && !adminData.result) {
				var displayName = googleRes.user.displayName || 'Era User';
				var parts = displayName.split(" ");
				var affiliateId = await this.generateAffiliateId({ token: userObj.stsTokenManager.accessToken });

				let value = {
					firstName: parts[0],
					lastName: displayName.replace(parts[0], "").trim(),
					email: googleRes.user.email,
					country: "Undefined",
					provider: "Apple.com",
					childs: [],
					regDate: new Date().getTime(),
					affiliateInfo: { affiliateId: affiliateId ? affiliateId : 0, clicks: 0, registrations: 0, freeMonthsEarned: 0 }
				}

				await firstValueFrom(this.activityService.createSelfData({ token: userObj.stsTokenManager.accessToken, parent: value }));
				await this.sleep(3000);

				this.loaderStatus = false;
				this.router.navigate(['/cabinet']);
			} else if (adminData.result) {
				adminData = adminData.result;

				adminData.id = googleRes.user.uid;

				if (adminData['role'] == "super_administrator") {
					localStorage.setItem('superAdmin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('superAdmin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('superAdmin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));

					await firstValueFrom(this.activityService.setSuperAdminAT({ token: userObj.stsTokenManager.accessToken }));

					this.router.navigate(['/admin/super/dashboard']);
				} else {
					localStorage.setItem('quranera_admin_accessToken', userObj.stsTokenManager.accessToken);
					localStorage.setItem('quranera_admin_expirationTime', userObj.stsTokenManager.expirationTime);
					localStorage.setItem('quranera_admin_userData', JSON.stringify({
						...adminData,
						uid: adminData.id
					}));
					this.router.navigate(['/admin']);
				}
			} else {
				this.loaderStatus = false;
				this.router.navigate(['/admin/cabinet']);
			}
		} else {
			localStorage.removeItem('currentUser');
			this.loaderStatus = false;
		}
	}

	async login(autologin = false) {
		this.loaderStatus = true;
		this.loginFaild = false;
		this.verify = false;

		const rawEmail = (this.emailFormControl.value || '').trim();
		const rawPassword = (this.passwordFormControl.value || '').trim();

		// Establish what input identifier we are evaluating (form value or saved credentials)
		const userInput = autologin && this.userCred ? this.userCred.uid : rawEmail;

		// Fast regex test to check if the input is an email format
		const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
		const isEmail = emailRegex.test(userInput);

		if (isEmail) {
			// 🏛️ PARENTS & TEACHERS / ADMINS (Email Path)
			try {
				const result = await this.auth.login(rawEmail, rawPassword);
				if (result.user) {
					localStorage.removeItem("cfal");

					let userStr = JSON.stringify(result.user);
					let userObj = JSON.parse(userStr);
					localStorage.setItem('currentUser', userStr);

					var adminData = await firstValueFrom(this.activityService.getSelfData({ collectionID: "adminUserData", token: userObj.stsTokenManager.accessToken }));

					if (adminData.result) {
						adminData = adminData.result;
						adminData.id = result.user.uid;

						if (adminData.role == "super_administrator") {
							localStorage.setItem('superAdmin_accessToken', userObj.stsTokenManager.accessToken);
							localStorage.setItem('superAdmin_expirationTime', userObj.stsTokenManager.expirationTime);
							localStorage.setItem('superAdmin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));

							await firstValueFrom(this.activityService.setSuperAdminAT({ token: userObj.stsTokenManager.accessToken }));

							this.router.navigate(['/admin/super/dashboard']);
						} else {
							localStorage.setItem('quranera_admin_accessToken', userObj.stsTokenManager.accessToken);
							localStorage.setItem('quranera_admin_expirationTime', userObj.stsTokenManager.expirationTime);
							localStorage.setItem('quranera_admin_userData', JSON.stringify({ ...adminData, uid: adminData.id }));
							this.router.navigate(['/admin']);
						}
					} else {
						var parentData = await firstValueFrom(this.activityService.getSelfData({ token: userObj.stsTokenManager.accessToken }));

						if (parentData.result) {
							this.router.navigate(['/admin/cabinet']);
							this.loaderStatus = false;
						} else {
							this.loginFaild = true;
							this.loaderStatus = false;
						}
					}
				} else {
					localStorage.removeItem('currentUser');
					this.loaderStatus = false;
				}
			} catch (error) {
				// Catch Fallback: In case a student logs in using an email address instead of a username
				this.loginWithTokenFlow(autologin);
			} finally {
				this.cdr.detectChanges();
			}
		} else {
			// 🎒 STUDENTS & CHILDREN (Username Path)
			this.loginWithTokenFlow(autologin);
		}
	}

	private async loginWithTokenFlow(autologin: boolean) {
		let passwordHash = Md5.hashStr((this.passwordFormControl.value || '').trim());
		let uid = (this.emailFormControl.value || '').trim();

		if (autologin && this.userCred) {
			passwordHash = this.userCred.passwordHash;
			uid = this.userCred.uid;
		}

		const currentOS = this.getCurrentOS();

		try {
			const token = await firstValueFrom(this.auth.getUserToken({ email: uid, password: passwordHash, userAgent: currentOS }));
			const userData = token.userData;

			// Protected Check: Ensure student has a valid school reference before trying to load it from Firestore
			if (userData.role == 'student' && userData.school && userData.school !== 'unset') {
				const isBlockedRef = await runInInjectionContext(this.injector, () => firstValueFrom(this.afs.collection("schoolsData").doc(userData.school).get()));
				const schoolStatus = isBlockedRef.data() as any;

				if (isBlockedRef.exists && schoolStatus && (schoolStatus.Status === "Expired" || schoolStatus.Status === "NotConverted" || schoolStatus.Status === "Inactive")) {
					localStorage.removeItem("cfal");
					this.loginBlocked = true;
					this.loaderStatus = false;
					this.cdr.detectChanges();
					return;
				}
			}

			localStorage.setItem('parentEmail', token.userData.parentEmail);

			try {
				const data = await this.auth.loginWithToken(token.token);
				let userStr = JSON.stringify(data.user);
				let userObj = JSON.parse(userStr);

				const userMeta = { school: null, class: null, role: null };

				if (userData.school && userData.school != 'unset') {
					userMeta['school'] = userData.school;
					userMeta['class'] = userData.class;
				}
				userMeta['role'] = userData.role;

				localStorage.setItem('currentUserMeta', JSON.stringify(userMeta));
				localStorage.setItem('accessToken', userObj.stsTokenManager.accessToken);
				localStorage.setItem('expirationTime', ((new Date()).getTime() + 3600000).toString());

				if (userData.role == 'student') {
					try {
						await this.assignmentService.load(uid);
					} catch (e) { }
				}

				localStorage.setItem('currentUser', JSON.stringify(userObj));

				if (userData) {
					this.user = userData;

					if (!this.signed) {
						localStorage.setItem("cfal", JSON.stringify({ uid, passwordHash }));
						this.signed = true;
					}

					this.loaderStatus = false;
					this.appendScriptToBody(token.userData.parentEmail);

					if (this.user.lastActivityId) {
						if (this.quizzes[this.user.lastActivityId]) this.router.navigate(['/game/' + this.quizzes[this.user.lastActivityId]]);
						else this.router.navigate(['/game/activity-list/' + this.user.lastActivityId]);
					} else {
						this.router.navigate(['/game']);
					}

					this.channel.postMessage({ action: 'LOGIN' });
				} else {
					localStorage.removeItem("cfal");
					this.loginFaild = true;
					this.loaderStatus = false;
				}
			} catch (error) {
				this.loginFaild = true;
				this.loaderStatus = false;
			}
		} catch (error) {
			this.loginFaild = true;
			this.loaderStatus = false;
		} finally {
			this.cdr.detectChanges();
		}
	}

	private getCurrentOS(): string {
		const userAgent = window.navigator.userAgent.toLowerCase();
		const platform = (window.navigator.platform || '').toLowerCase();

		if (/iphone|ipad|ipod/.test(userAgent)) return "iOS";
		if (/android/.test(userAgent)) return "Android";
		if (/windows nt/.test(userAgent) || platform.indexOf('win') !== -1) return "Windows";
		if (/macintosh|macintel|macppc|mac68k/.test(userAgent) || platform.indexOf('mac') !== -1) return "MacOS";
		if (/linux/.test(userAgent) || platform.indexOf('linux') !== -1) return "Linux";
		return "Unknown";
	}

	async loginViaQRCode(qrData) {
		window.location.href = "https://app.quranera.com/login?qrmode=" + qrData;
		return;

		/* Left here in case fallback flow is ever reactivated */
		const currentOS = this.getCurrentOS();

		try {
			const token = await firstValueFrom(this.auth.getUserTokenViaID({ qrData, userAgent: currentOS }));
			const userData = token.userData;

			// Protected Check: Ensure QR-authenticated student has a valid school linked
			if (userData.role === 'student' && userData.school && userData.school !== 'unset') {
				const isBlockedRef = await runInInjectionContext(this.injector, () => firstValueFrom(this.afs.collection("schoolsData").doc(userData.school).get()));

				if (isBlockedRef.exists) {
					const schoolData = isBlockedRef.data() as any;

					if (schoolData && (schoolData.Status === "Expired" || schoolData.Status === "NotConverted")) {
						localStorage.removeItem("cfal");
						this.loginBlocked = true;
						this.loaderStatus = false;
						this.cdr.detectChanges();
						return;
					}
				}
			}

			try {
				const data = await this.auth.loginWithToken(token.token);
				let userStr = JSON.stringify(data.user);
				let userObj = JSON.parse(userStr);

				const userMeta = { school: null, class: null, role: null }

				if (userData.school && userData.school != 'unset') {
					userMeta['school'] = userData.school;
					userMeta['class'] = userData.class;
				}
				userMeta['role'] = userData.role;

				localStorage.setItem('currentUserMeta', JSON.stringify(userMeta));
				localStorage.setItem('accessToken', userObj.stsTokenManager.accessToken);
				localStorage.setItem('expirationTime', ((new Date()).getTime() + 3600000).toString());

				if (userData.role == 'student') {
					try {
						await this.assignmentService.load(data.user.uid);
					} catch (e) { }
				}

				localStorage.setItem('currentUser', JSON.stringify(userObj));

				if (userData) {
					this.user = userData;
					this.loaderStatus = false;
					this.appendScriptToBody(token.userData.parentEmail);

					if (this.user.lastActivityId) {
						if (this.quizzes[this.user.lastActivityId]) this.router.navigate(['/game/' + this.quizzes[this.user.lastActivityId]]);
						else this.router.navigate(['/game/activity-list/' + this.user.lastActivityId]);
					} else {
						this.router.navigate(['/game']);
					}
					this.channel.postMessage({ action: 'LOGIN' });
				} else {
					localStorage.removeItem("cfal");
					this.loginFaild = true;
					this.loaderStatus = false;
				}
			} catch (error) {
				this.loginFaild = true;
				this.loaderStatus = false;
			}
		} catch (error) {
			this.loginFaild = true;
			this.loaderStatus = false;
		} finally {
			this.cdr.detectChanges();
		}
	}

	sleep(ms) {
		return new Promise(resolve => setTimeout(resolve, ms));
	}
}
